import { render } from "./ReceivableChannels.vue?vue&type=template&id=b620dbf0&scoped=true"
import script from "./ReceivableChannels.vue?vue&type=script&lang=js"
export * from "./ReceivableChannels.vue?vue&type=script&lang=js"

import "./ReceivableChannels.vue?vue&type=style&index=0&id=b620dbf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b620dbf0"]])

export default __exports__